import styled from 'styled-components';
import {
  border,
  borderRadius,
  color,
  flexbox,
  grid,
  layout,
  lineHeight,
  position,
  shadow,
  space,
  system,
  textAlign,
  typography,
} from 'styled-system';
import { StyledSystemProps } from '../../types';

type BoxProps = StyledSystemProps & {
  animationIterationCount?: number | 'infinite';
  animation?: string;
};

const animation = system({
  animationIterationCount: true,
  animation: true,
});

const Box = styled.div<BoxProps>`
  box-sizing: border-box;
  margin: 0;

  ${space}
  ${layout}
  ${lineHeight}
  ${color}
  ${typography}
  ${flexbox}
  ${grid}
  ${position}
  ${borderRadius}
  ${border}
  ${shadow}
  ${textAlign}
  ${animation}
`;

export { Box };
